import React, { useContext, useMemo } from 'react';
import { context as Context } from '@gp/components/Context';
import MultipleLinesTextBubble from '@gp/components/MultipleLinesTextBubble';
import MetricsCard3 from '@gp/pages/StudioDashboard/StudioOverall/components/MetricsCard3';
import { round, getRoundIntegerNum, formatDateStr } from '@gp/utils/common';
import { FIELDS1, FIELD_NAMES } from '@gp/utils/metricTips';
import { getNumValueText } from '@gp/pages/StudioDashboard/StudioOverall/utils';

import type { IKeyMetricsMetric } from '../../types';

import PersonIcon from '@gp/assets/svg/gameInformation/person.svg';

const TotalFulltimeEmployeeCard: React.FC<IStudioOverallTotalFulltimeEmployeeCardProps> = (props) => {
  const { value, ratio, hiringOfLastYear, hiringOfThisYear, dataTime } = props;

  const { commonData } = useContext<IStudioOverallOverviewContext>(Context);

  const metrics = useMemo<IKeyMetricsMetric[]>(
    () => [
      {
        metricName: `${commonData?.lastYear} FTE`,
        metricValue: getNumValueText(hiringOfLastYear),
      },
      {
        metricName: 'HC increase in this year',
        metricValue: getNumValueText(hiringOfThisYear),
        isGrowth: true,
      },
    ],
    [commonData?.lastYear, hiringOfLastYear, hiringOfThisYear],
  );

  return (
    <MetricsCard3
      isTitleMultipleLinesTextBubble
      multipleLinesTextFields={FIELDS1}
      multipleLinesTextFieldNames={FIELD_NAMES}
      multipleLinesTextData={{
        definition: 'Total in house full-time employee of all portfolio studios.',
        source: 'Studio Reporting Package',
        updateCadence: 'Monthly',
      }}
      title="Total full-time employees"
      date={formatDateStr(dataTime, 'YYYY-MM')}
      icon={<img src={PersonIcon} />}
      value={getRoundIntegerNum(value)}
      // @ts-ignore
      ratio={round(ratio)}
      metrics={metrics}
    />
  );
};

export default React.memo(TotalFulltimeEmployeeCard);
